module.exports = __webpack_public_path__ + "img/404.60833642.gif";